import { BaseMetric } from './baseMetric'
import {
	AddEvent,
	ClickEvent,
	DeleteEvent,
	EditEvent,
	ViewEvent,
} from '~/passporter-services/shared/metrics'
import { Destination2 } from '~/models/Destination'
import mixpanel from 'mixpanel-browser'
import { Itinerary2 } from '~/models/Itinerary'

type AddSpotParams = {
	source?: 'itinerary' | 'spots' | 'spots_collections'
	section: 'saved' | 'itinerary'
	spotId: string
	spotTitle: string
	tripId: string
	destinationName: string
	userRole: string
	routeName?: string
}

type AddCollectionParams = {
	tripId: string
	destinationName: string
	userRole: string
	routeName: string
	collectionId: string
	collectionTitle: string
}

export class TripMetric extends BaseMetric {
	public static createTrip(itinerary: Itinerary2) {
		const destination: Destination2 | undefined = itinerary.destinations
			? itinerary.destinations[0]
			: undefined
		if (!destination) return

		const destinationName = destination.name || ''
		const destinationId = destination.id || ''
		new ClickEvent('trip')
			.action('Itinerary Created')
			.addParam('destination_name', destinationName)
			.addParam('destination_id', destinationId)
			.addParam('itinerary_id', itinerary.id || '')
			.send(this.gtag, mixpanel)
	}

	public static emptyTripTracker() {
		this.homeTracker('plan', 'empty')
	}

	public static engagedTripTracker() {
		this.homeTracker('plan', 'engaged')
	}

	public static emptyDiscoverTracker() {
		this.homeTracker('discover', 'empty')
	}

	public static engagedDiscoverTracker() {
		this.homeTracker('discover', 'engaged')
	}

	public static emptyPastTripTracker() {
		this.homeTracker('fulfill', 'empty')
	}

	public static engagedPastTripTracker() {
		this.homeTracker('fulfill', 'engaged')
	}

	private static homeTracker(element: string, type: 'empty' | 'engaged') {
		const context = 'home'
		new ClickEvent(element, context).type(type).send(this.gtag, mixpanel)
	}

	public static viewDashboard(id: string, destination: string, routeName?: string): void {
		new ViewEvent('home', routeName).id(id).destination(destination).send(this.gtag, mixpanel)
	}

	public static viewTrip(id: string, destination: string, routeName?: string): void {
		new ViewEvent('spots', routeName).id(id).destination(destination).send(this.gtag, mixpanel)
	}

	public static viewItinerary(id: string, destination: string, routeName?: string): void {
		new ViewEvent('itinerary', routeName).id(id).destination(destination).send(this.gtag, mixpanel)
	}

	public static viewCreationStep(step: string, routeName?: string): void {
		new ViewEvent('wizard', routeName).addParam('step', step).send(this.gtag, mixpanel)
	}

	public static deleteMedia(itineraryId: string, routeName?: string): void {
		new DeleteEvent('media', routeName).id(itineraryId).num(1).send(this.gtag, mixpanel)
	}

	public static addMedia(itineraryId: string, routeName?: string): void {
		new AddEvent('media', routeName).id(itineraryId).num(1).send(this.gtag, mixpanel)
	}

	public static addSpotOn(params: AddSpotParams): void {
		const event = new AddEvent('spot', params.routeName).addParam('section', params.section, false)

		if (params.source) {
			event.addParam('source', params.source, false)
		}

		event
			.addParam('trip_id', params.tripId)
			.addParam('trip_destination', params.destinationName)
			.addParam('user_role', params.userRole)
			.addParam('id', params.spotId, false)
			.addParam('title', params.spotTitle, false)
			.send(this.gtag, mixpanel)
	}

	public static addCollectionOn(params: AddCollectionParams): void {
		new AddEvent('collection', params.routeName)
			.addParam('section', 'saved', false)
			.addParam('trip_id', params.tripId)
			.addParam('trip_destination', params.destinationName)
			.addParam('user_role', params.userRole)
			.addParam('id', params.collectionId, false)
			.addParam('title', params.collectionTitle, false)
			.send(this.gtag, mixpanel)
	}

	public static addTimeslot(
		tripId: string,
		destinationName: string,
		userRole: string,
		routeName?: string
	): void {
		new AddEvent('time_slot', routeName)
			.addParam('trip_id', tripId)
			.addParam('trip_destination', destinationName)
			.addParam('user_role', userRole)
			.send(this.gtag, mixpanel)
	}

	public static editTimeslot(
		tripId: string,
		destinationName: string,
		userRole: string,
		routeName?: string
	): void {
		new EditEvent('time_slot', routeName)
			.action('edit')
			.addParam('trip_id', tripId)
			.addParam('trip_destination', destinationName)
			.addParam('user_role', userRole)
			.send(this.gtag, mixpanel)
	}
	public static deleteTimeslot(
		tripId: string,
		destinationName: string,
		userRole: string,
		routeName?: string
	): void {
		new DeleteEvent('time_slot', routeName)
			.addParam('trip_id', tripId)
			.addParam('trip_destination', destinationName)
			.addParam('user_role', userRole)
			.send(this.gtag, mixpanel)
	}
}
